import { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { TeachersTab } from '../components/masterdata/TeachersTab';
import { SubjectsTab } from '../components/masterdata/SubjectsTab';
import { ClassesTab } from '../components/masterdata/ClassesTab';
import { RoomsTab } from '../components/masterdata/RoomsTab';
import { ClassSchedulesTab } from '../components/masterdata/ClassSchedulesTab';
import { TeacherClassAssignmentTab } from '../components/masterdata/TeacherClassAssignmentTab';
import { SubjectClassAssignmentTab } from '../components/masterdata/SubjectClassAssignmentTab';
import { useAuthStore } from '../store/authStore';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`masterdata-tabpanel-${index}`}
      aria-labelledby={`masterdata-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export function MasterDataPage() {
  const [currentTab, setCurrentTab] = useState(0);
  const { schoolContext } = useAuthStore();
  const schoolId = schoolContext || '';

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Master Data Management
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="master data tabs">
          <Tab label="Subjects" id="masterdata-tab-0" aria-controls="masterdata-tabpanel-0" />
          <Tab label="Teachers" id="masterdata-tab-1" aria-controls="masterdata-tabpanel-1" />
          <Tab label="Classes" id="masterdata-tab-2" aria-controls="masterdata-tabpanel-2" />
          <Tab label="Rooms" id="masterdata-tab-3" aria-controls="masterdata-tabpanel-3" />
          <Tab label="Class Schedules" id="masterdata-tab-4" aria-controls="masterdata-tabpanel-4" />
          <Tab label="Teacher-Class" id="masterdata-tab-5" aria-controls="masterdata-tabpanel-5" />
          <Tab label="Subject-Class" id="masterdata-tab-6" aria-controls="masterdata-tabpanel-6" />
        </Tabs>
      </Box>

      <TabPanel value={currentTab} index={0}>
        <SubjectsTab />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <TeachersTab />
      </TabPanel>

      <TabPanel value={currentTab} index={2}>
        <ClassesTab schoolId={schoolId} />
      </TabPanel>

      <TabPanel value={currentTab} index={3}>
        <RoomsTab />
      </TabPanel>

      <TabPanel value={currentTab} index={4}>
        <ClassSchedulesTab schoolId={schoolId} />
      </TabPanel>

      <TabPanel value={currentTab} index={5}>
        <TeacherClassAssignmentTab schoolId={schoolId} />
      </TabPanel>

      <TabPanel value={currentTab} index={6}>
        <SubjectClassAssignmentTab schoolId={schoolContext || ''} />
      </TabPanel>
    </Box>
  );
}
